import * as React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export default function CustomCommandCellOrders(props) {
    const { dataItem, remove } = props;

    return (

        <td className="k-command-cell">

            <Link to={'/DetailsOrders/'}>
                <button className="k-button k-button-icontext" style={{ marginRight: "5px" }}>
                    <span className="k-icon k-i-pencil" title="Editar"></span>
                </button>
            </Link>

            <button className="k-button k-grid-remove-command" onClick={() => remove(dataItem)}>
                <span className="k-icon k-i-delete" title="Eliminar"></span>
            </button>

        </td>
    );
}
